import {
  BrowserRouter as Router,
  Route,
  Link,
  Routes
} from "react-router-dom";
import React, { useContext, useState } from 'react';
import './App.css';
import Loading from './component/loading';
import { GlobalContext } from "./context/provider";
import Login from "./component/login";
import Home from "./component/home";
import { BiLogOut } from "react-icons/bi";
import { AiOutlineMenu } from "react-icons/ai";
import Menu from "./component/menu";
import User from "./pages/user/user";
import Expensetype from "./pages/expensetype/expensetype";
import Expense from "./pages/expense/expense";
import Category from "./pages/category/category";
import Company from "./pages/company/company";
import Item from "./pages/item/item";
import Buy from "./pages/buy/buy";
import Sell from "./pages/sell/sell";
import Buyinvoice from "./pages/buyinvoice/buyinvoice";
import Report from "./pages/report/report";
import Broke from "./pages/broke/broke";
import Barcode from "./pages/barcode/barcode";
import './component/css/onprintcss.css';
import Returnbybarcode from "./pages/returnbybarcode/returnbybarcode";
import Return_item_company from "./pages/return_item_company/return_item_company";
import Deleteditem from "./pages/deleteditem/deleteditem";
import Sellinvoicelist from "./pages/sellinvoicelist/sellinvoicelist";
import Unit from "./pages/unit/unit";
import Customer from "./pages/customer/customer";
import Setting from "./pages/setting/setting";
import Jard from "./pages/report/jard/jard";
import Sell_Report from "./pages/report/sell/sell";
import Expense_Report from "./pages/report/expense/expense";
import Customer_Loan_Report from "./pages/report/customer_loan/customer_loan";
import Company_Loan_Report from "./pages/report/company_loan/company_loan";
import Broke_Report from "./pages/report/broke/broke";
import Summary_Report from "./pages/report/summary/summary";
import Customerledger from "./pages/customer/customerledger";
import Testt from "./pages/setting/testt";
import Nointernet from "./component/nointernet";
import Remained_item from "./pages/remained_item/remained_item";
import Mizania from "./pages/mizania/mizania";
import Companyledger from "./pages/company/companyledger";
import Report_Mizania from "./pages/report/mizania/report_mizania";
import Mizania_customer_ledger from "./pages/report/mizania/mizania_customer_loan/mizania_customer_ledger";
import Mizania_company_ledger from "./pages/report/mizania/mizania_company_loan/mizania_company_ledger";
import Itemledger from "./pages/item/itemledger";


function App() {
  const { initState, clear } = useContext(GlobalContext);
  const [hide_menu, sethide_menu] = useState(true);

  return (
    <Router>
      {initState.loading ? (
        <Loading />
      ) : (
        <Routes>
          {/* ✅ Public route */}
          <Route path="/nointernet" element={<Nointernet />} />

          {/* ✅ Protected routes */}
          <Route
            path="/*"
            element={
              initState.islogin && initState.token != null ? (
                <div className="w-full h-screen flex" dir="rtl">
                  {/* Sidebar */}
                  <div
                    className={`static ${hide_menu ? "hidden" : "block"} 
                      w-full md:w-72 h-full z-50 border-r border-gray-400
                      transition-transform duration-500 ease-in-out
                      absolute md:relative
                      ${hide_menu ? "translate-x-full" : "translate-x-0"}
                    `}
                  >
                    <Menu hide_menu={hide_menu} sethide_menu={sethide_menu} />
                  </div>

                  {/* Main Content */}
                  <div className={hide_menu ? "w-full h-full" : "w-full max-h-[100vh] overflow-y-hidden"}>
                    {/* Top Bar */}
                    <div className="w-full h-16 border-b-2 flex md:justify-between justify-between items-center px-10 print_hide">
                      <AiOutlineMenu
                        size={30}
                        className="cursor-pointer"
                        onClick={() => sethide_menu(!hide_menu)}
                      />
                      <BiLogOut
                        size={30}
                        className="cursor-pointer"
                        onClick={() => clear()}
                      />
                    </div>

                    {/* Role-based Routes */}
                    <Routes>
                      {initState.token.role === "admin" ? (
                        <>
                          <Route path="/" element={<Sell />} />
                          <Route path="/sellinvoicelist" element={<Sellinvoicelist />} />
                          <Route path="/user" element={<User />} />
                          <Route path="/returnitemtocompany" element={<Return_item_company />} />
                          <Route path="/item" element={<Item />} />
                          <Route path="/item/ledger" element={<Itemledger />} />
                          <Route path="/removeditem" element={<Deleteditem />} />
                          <Route path="/category" element={<Category />} />
                          <Route path="/unit" element={<Unit />} />
                          <Route path="/buy" element={<Buy />} />
                          <Route path="/buyinvoice" element={<Buyinvoice />} />
                          <Route path="/company" element={<Company />} />
                          <Route path="/company/ledger" element={<Companyledger />} />
                          <Route path="/customer" element={<Customer />} />
                          <Route path="/customer/ledger" element={<Customerledger />} />
                          <Route path="/setting" element={<Setting />} />
                          <Route path="/expensetype" element={<Expensetype />} />
                          <Route path="/expense" element={<Expense />} />
                          <Route path="/broke" element={<Broke />} />
                          <Route path="/remained_item" element={<Remained_item />} />
                          <Route path="/barcode" element={<Barcode />} />
                          <Route path="/report" element={<Report />} />
                          <Route path="/report/stock" element={<Jard />} />
                          <Route path="/report/sell" element={<Sell_Report />} />
                          <Route path="/report/expense" element={<Expense_Report />} />
                          <Route path="/report/customer_loan" element={<Customer_Loan_Report />} />
                          <Route path="/report/company_loan" element={<Company_Loan_Report />} />
                          <Route path="/report/broke" element={<Broke_Report />} />
                          <Route path="/report/summary" element={<Summary_Report />} />
                          <Route path="/report/mizania" element={<Report_Mizania />} />
                          <Route path="/report/mizania/customer_ledger" element={<Mizania_customer_ledger />} />
                          <Route path="/report/mizania/company_ledger" element={<Mizania_company_ledger />} />
                          <Route path="/mizan" element={<Mizania />} />
                        </>
                      ) : (
                        <>
                          <Route path="/" element={<Sell />} />
                          <Route path="/user" element={<User />} />
                          <Route path="/item" element={<Item />} />
                        </>
                      )}
                    </Routes>
                  </div>
                </div>
              ) : (
                <Login />
              )
            }
          />
        </Routes>
      )}
    </Router>
  );
}

export default App;
